export enum TTSModels {
  ELEVEN_MULTILINGUAL_V2 = "eleven_multilingual_v2",
  ELEVEN_TURBO_V2_5 = "eleven_turbo_v2_5",
  ELEVEN_V3 = "eleven_v3",
}
export const ttsModels = [
  {
    label: "eleven_multilingual_v2",
    value: TTSModels.ELEVEN_MULTILINGUAL_V2,
  },
  {
    label: "eleven_turbo_v2_5",
    value: TTSModels.ELEVEN_TURBO_V2_5,
  },
  {
    label: "eleven_v3",
    value: TTSModels.ELEVEN_V3,
  },
] as const;

export const ttsModelsSupportedV2nV3 = {
  [TTSModels.ELEVEN_MULTILINGUAL_V2]: true,
  // [TTSModels.ELEVEN_TURBO_V2_5]: true,
  [TTSModels.ELEVEN_V3]: true,
};

export const ttsModelsSupportedV2 = {
  [TTSModels.ELEVEN_MULTILINGUAL_V2]: true,
  // [TTSModels.ELEVEN_TURBO_V2_5]: true,
};

export const ttsModelsSupportedV3 = {
  [TTSModels.ELEVEN_V3]: true,
};

// New configuration for languages that support ELEVEN_TURBO_V2_5
export const ttsModelsSupportedV2nV3WithTurboV2_5 = {
  [TTSModels.ELEVEN_MULTILINGUAL_V2]: true,
  [TTSModels.ELEVEN_TURBO_V2_5]: true,
  [TTSModels.ELEVEN_V3]: true,
};

export type TTSModel = (typeof ttsModels)[number]["value"];
